import {ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy as AngularDefaultRouteReuseStrategy} from '@angular/router';

export class RouteReuseStrategy implements AngularDefaultRouteReuseStrategy {

	public shouldDetach(route: ActivatedRouteSnapshot): boolean {
		return false;
	}

	public store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle|null): void {

	}

	public shouldAttach(route: ActivatedRouteSnapshot): boolean {
		return false;
	}

	public retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle|null {
		return null;
	}

	public shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
		return false;
	}
}